import {Page} from '@blesk-frontend/ui';
import {ReactNode} from 'react';
import {useStaffId} from '../hooks';
import {AuthInfoStartLogo} from './AuthInfoStartLogo';

interface AuthPageProps {
  children: ReactNode;
  footer?: ReactNode;
}

export const AuthPage = ({children, footer}: AuthPageProps) => {
  const staffId = useStaffId();

  return (
    <Page className="flex w-full flex-col gap-6 rounded-lg bg-bg-secondary p-8">
      {staffId === import.meta.env.VITE_INFOSTART_STAFF_ID && (
        <div className="mx-auto">
          <AuthInfoStartLogo />
        </div>
      )}
      {children}
      {footer && (
        <>
          <div className="-mx-8 h-px bg-border-primary" />
          {footer}
        </>
      )}
    </Page>
  );
};
